import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import type {
  ProgressBarDefinition,
  ProgressBarProps,
  ProgressBarCSSVars,
} from '../ProgressBar.types';
import {
  getScaledFont,
  withSiteDirection,
} from '@wix/editor-elements-common-utils';
import { getInnerBorderRadius } from './helpers';
import {
  castToInheritIfNeeded,
  withFallbackValues,
  type LogicalAlignment,
} from '@wix/editor-elements-common-utils';

export const props = withCompInfo<ProgressBarProps, ProgressBarDefinition>()(
  ['compData'],
  ({ compData }) => {
    return {
      value: compData.value,
      targetValue: compData.targetValue,
      label: compData.label,
    };
  },
);

export const css = withCompInfo<ProgressBarCSSVars, ProgressBarDefinition>()(
  [
    'compProps',
    'compData',
    'styleProperties',
    'compLayout',
    'isMobileView',
    'siteFonts',
    'siteFontsSpxResolved',
  ],
  ({
    compProps,
    compData,
    styleProperties,
    compLayout,
    isMobileView,
    siteFonts,
    siteFontsSpxResolved,
  }): ProgressBarCSSVars => {
    const {
      direction = 'inherit',
      labelDirection = 'inherit',
      barDirection = 'inherit',
    } = compData;
    const {
      borderRadius = '0px',
      borderSize = '0px',
      align = 'start',
      labelPadding,
      labelMargin,
    } = styleProperties as Record<string, string> & {
      align: LogicalAlignment;
    };

    const paddingByAlignment = () =>
      align !== 'center'
        ? { [`--label-padding-${align}`]: `${labelPadding}px` }
        : {};

    const compInfo = {
      styleProperties,
      compLayout,
      compProps,
      isMobileView,
      siteFonts,
      siteFontsSpxResolved,
    };

    return {
      '--fntlbl': getScaledFont(compInfo, 'fntlbl', undefined, 16),
      '--direction': withSiteDirection(direction),
      '--label-direction': labelDirection,
      '--bar-direction': barDirection,
      '--align': align,
      '--borderRadius': borderRadius,
      '--borderSize': borderSize,
      '--innerBorderRadius': getInnerBorderRadius(borderRadius, borderSize),
      '--label-margin-bottom': `${labelMargin}px`,
      ...paddingByAlignment(),
    };
  },
  [
    withFallbackValues([
      {
        sourceNamespace: 'compProps',
        targetNamespace: 'compData',
        fields: [{ source: 'direction', target: 'direction' }],
        enhancer: direction => castToInheritIfNeeded(direction, 'ltr'),
      },
    ]),
  ],
);

export default createComponentMapperModel({ css, props });
